export default "__VITE_ASSET__Bgyl9jfo__"